export default "__VITE_ASSET__CS9ix_b1__"